/**
 * Why the memory routes answered 409: `{"detail": {"code": ...}}` from the
 * API. `stale`: the target changed since the learning was written. `closed`:
 * the learning is no longer open (someone else decided it, or it was undone).
 * `refused`: the content checks refused the approval.
 */
export type ConflictCode = 'stale' | 'closed' | 'refused';

/** What a row or a toast says for each, one wording for the page and the chat. */
export const CONFLICT_WORDS: Record<ConflictCode, string> = {
  stale: 'Changed since',
  closed: 'No longer open',
  refused: 'Not saved',
};

/**
 * The code of a 409, `stale` when the reply names none, and null for any other
 * failure.
 */
export function conflictCode(error: unknown): ConflictCode | null {
  const { status, data } = (error ?? {}) as {
    status?: unknown;
    data?: unknown;
  };
  if (status !== 409) return null;
  const code = (data as { detail?: { code?: unknown } } | null)?.detail?.code;
  return code === 'closed' || code === 'refused' ? code : 'stale';
}

/**
 * The server's words on a 409, when it gives them: a voice or proof change
 * the settings or profile save refused says why. Null otherwise.
 */
export function conflictMessage(error: unknown): string | null {
  if (conflictCode(error) === null) return null;
  const data = (error as { data?: unknown }).data;
  const detail = (data as { detail?: unknown } | null | undefined)?.detail;
  const message =
    detail && typeof detail === 'object'
      ? (detail as { message?: unknown }).message
      : undefined;
  return typeof message === 'string' && message.trim() ? message.trim() : null;
}
